import {
  ActionReducerMapBuilder,
  createAction,
  createAsyncThunk,
} from '@reduxjs/toolkit';

import { ChatService } from '../chat.service';
import { ThunkExtra, RequestStatus } from '../../utils';
import { loadScript } from '../../external-resource';

import { ChatState } from './chat.state';

const setStatus = createAction<RequestStatus>('chat/setStatus');

export const loadChat = createAsyncThunk<
  void,
  undefined,
  ThunkExtra<{ chat: ChatState }>
>('core/chat/loadChat', async (_, { dispatch, extra: { inject } }) => {
  try {
    dispatch(setStatus('loading'));

    const service = inject(ChatService);

    const credentials = await service.getSupportCredentials();

    window.webim = {
      accountName: window.REACT_APP_VKHRTEK_WEBIM_ACCOUNT_NAME,
      domain: `${window.REACT_APP_VKHRTEK_WEBIM_ACCOUNT_NAME}.webim.ru`,
      location: 'hr_box',
    };
    window.webim_visitor = credentials;

    loadScript(
      `https://${window.REACT_APP_VKHRTEK_WEBIM_ACCOUNT_NAME}.webim.ru/js/button.js`,
      { defer: true },
    );

    const intervalTime = 100;

    const intervalId = setInterval(() => {
      if (window.webim.api && document.querySelector('.webim-button-corner')) {
        dispatch(setStatus('complete'));
        window.webim.api.chat.start();
        clearInterval(intervalId);
      }
    }, intervalTime);
  } catch (e) {
    dispatch(setStatus('failed'));
  }
});

export const chatReducers = (builder: ActionReducerMapBuilder<ChatState>) => {
  builder.addCase(setStatus, (state, action) => {
    state.status = action.payload;
  });
};
